module.exports = __webpack_public_path__ + "img/allow-blue-down.34647213.svg";